"use client";

import { QuickTradeForm } from "@shared/src/components/modules/quick-trade/QuickTradeForm";
import { QuickTradeSearching } from "@shared/src/components/modules/quick-trade/QuickTradeSearching";
import MerchantFound from "@shared/src/components/modules/quick-trade/MerchantFound";
import { QuickTradeAnimatedContainer } from "@shared/src/components/modules/quick-trade/QuickTradeAnimatedContainer";
import { useQuickTrade } from "@shared/src/hooks/quick-trade/useQuickTrade";
import { QuickTradeExpiredView } from "@shared/src/components/modules/quick-trade/QuickTradeExpiredView";
import { useQuickTradeOptions } from "@shared/src/hooks/quick-trade/useQuickTradeOptions";
import { QuickTradeSkeleton } from "@shared/src/components/ui/common/skeletons/QuickTradeSkeleton";
import { useNotificationStore } from "@shared/src/stores/useNotificationStore";

export function QuickTradeView() {
  const { view, submitTrade, cancelTrade, form } = useQuickTrade();
  const quickTradeNotification = useNotificationStore(state => state.quickTradeNotification);
  const quickTrade = quickTradeNotification?.quickTrade;

  const options = useQuickTradeOptions();

  console.log("QuickTradeView render", { view, options });
  // Use the options loading state to show the skeleton
  // Defensive normalize: if we land on an unsupported state for this page, treat it as form
  const normalizedView = view === "p2p_flow" || view === "incoming_order" ? "form" : view;
  const isSearching = normalizedView === "searching" && !!quickTrade;
  const isMerchantFound = normalizedView === "merchant_found";
  const isForm = normalizedView === "form";
  const isExpired = normalizedView === "expired";

  return (
    <>
      {/* Merchant Found State */}
      <QuickTradeAnimatedContainer isVisible={isMerchantFound} animation="slide-up" duration={300} delay={300}>
        {isMerchantFound && (
          <MerchantFound
            traderChainId={quickTrade?.traderChain || 0}
            onCancel={cancelTrade}
            paymentMethod={quickTrade?.paymentMethod || "not found"}
            orderQuantity={quickTrade?.quantity || 0}
          />
        )}
      </QuickTradeAnimatedContainer>
      {/* Form State */}
      <QuickTradeAnimatedContainer isVisible={isForm} animation="slide-up" duration={300}>
        {options.isLoading ? (
          <QuickTradeSkeleton />
        ) : (
          <QuickTradeForm onSubmit={submitTrade} form={form} options={options} />
        )}
      </QuickTradeAnimatedContainer>

      {/* Searching State */}
      <QuickTradeAnimatedContainer
        isVisible={isSearching}
        animation="slide-left"
        duration={300}
        exitAnimation={"slide-right"}
      >
        {isSearching && <QuickTradeSearching formData={quickTrade} onCancel={cancelTrade} />}
      </QuickTradeAnimatedContainer>

      {/* Expired State */}
      <QuickTradeAnimatedContainer isVisible={isExpired} animation="slide-left" duration={300}>
        <QuickTradeExpiredView />
      </QuickTradeAnimatedContainer>
    </>
  );
}

